/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { PutCall } from './PutCall';
import {
    PutCallFromJSON,
    PutCallFromJSONTyped,
    PutCallToJSON,
} from './PutCall';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface ClosedLot
 */
export interface ClosedLot {
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    description?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof ClosedLot
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof ClosedLot
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof ClosedLot
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    referencePortfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    allocationType?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    investmentAlgo: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    investmentSleeve: string;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    costBasis: number;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    nav: number;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    coId?: string;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    mic?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    settlementMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    minTick?: number;
    /**
     * 
     * @type {PutCall}
     * @memberof ClosedLot
     */
    putCall?: PutCall;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    underlyingSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof ClosedLot
     */
    closedLotId: string;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    tradePrice: number;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    pnlRealized: number;
    /**
     * 
     * @type {number}
     * @memberof ClosedLot
     */
    returnRealized?: number;
}



/**
 * Check if a given object implements the ClosedLot interface.
 */
export function instanceOfClosedLot(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "investmentAlgo" in value;
    isInstance = isInstance && "investmentSleeve" in value;
    isInstance = isInstance && "costBasis" in value;
    isInstance = isInstance && "nav" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "closedLotId" in value;
    isInstance = isInstance && "tradePrice" in value;
    isInstance = isInstance && "pnlRealized" in value;

    return isInstance;
}

export function ClosedLotFromJSON(json: any): ClosedLot {
    return ClosedLotFromJSONTyped(json, false);
}

export function ClosedLotFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClosedLot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'aC': json['a_c'],
        'sId': json['s_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'quantity': json['quantity'],
        'side': json['side'],
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : json['allocation_type'],
        'investmentAlgo': json['investment_algo'],
        'investmentSleeve': json['investment_sleeve'],
        'costBasis': json['cost_basis'],
        'nav': json['nav'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'putCall': !exists(json, 'put_call') ? undefined : PutCallFromJSON(json['put_call']),
        'underlyingSymbol': !exists(json, 'underlying_symbol') ? undefined : json['underlying_symbol'],
        'brokerId': json['broker_id'],
        'closedLotId': json['closed_lot_id'],
        'tradePrice': json['trade_price'],
        'pnlRealized': json['pnl_realized'],
        'returnRealized': !exists(json, 'return_realized') ? undefined : json['return_realized'],
    };
}

export function ClosedLotToJSON(value?: ClosedLot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'a_c': value.aC,
        's_id': value.sId,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'quantity': value.quantity,
        'side': value.side,
        'reference_portfolio': value.referencePortfolio,
        'allocation_type': value.allocationType,
        'investment_algo': value.investmentAlgo,
        'investment_sleeve': value.investmentSleeve,
        'cost_basis': value.costBasis,
        'nav': value.nav,
        'sc_id': value.scId,
        'co_id': value.coId,
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
        'symbol': value.symbol,
        'primary_exchange': value.primaryExchange,
        'cusip': value.cusip,
        'isin': value.isin,
        'sedol': value.sedol,
        'country': value.country,
        'mic': value.mic,
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'issuer': value.issuer,
        'coupon': value.coupon,
        'maturity_date': value.maturityDate,
        'issue_date': value.issueDate,
        'expiration_date': value.expirationDate,
        'first_notice_date': value.firstNoticeDate,
        'settlement_method': value.settlementMethod,
        'min_tick': value.minTick,
        'put_call': PutCallToJSON(value.putCall),
        'underlying_symbol': value.underlyingSymbol,
        'broker_id': value.brokerId,
        'closed_lot_id': value.closedLotId,
        'trade_price': value.tradePrice,
        'pnl_realized': value.pnlRealized,
        'return_realized': value.returnRealized,
    };
}

